import state from "./state";
import getters from "./getters";
import mutations from "./mutations";
import actions from "./actions";

export default {
  autoload: true, // Load store on Vue startup
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
